import { ObservableFromFetch } from "../ObservableFromFetch"
import ValidatePINModel from "./Model/ValidatePINModel"

export default function ValidateOneTimePIN(params: ValidatePINModel) {
    const requestBody = JSON.stringify(params)
    return ObservableFromFetch<string>("FFOrderClinicStatus/ValidateOneTimePin", requestBody)
}
